import $ from "jquery";
var scope = getScopeUrlParam();
var hsaId = getHsaIdUrlParam();
var scopeQuery = "";
var hsaIdQuery = ""
if (scope)
    scopeQuery = "&s=" + scope;
if (hsaId) hsaIdQuery = "&hsaids=" + hsaId;

var scope = getScopeUrlParam();
var hsaId = getHsaIdUrlParam();
var scopeQuery = "";
var hsaIdQuery = ""
if (scope)
    scopeQuery = "&s=" + scope;
if (hsaId) hsaIdQuery = "&hsaids=" + hsaId;

const lang = document.documentElement.getAttribute('lang');

function handleKeyDown(event) {
    var resultContainer = $("#autocomplete-result");
    var searchButton = $("#search-button");
    var searchField = $("#search");
    switch (event.key) {
        case 'ArrowDown':
        case 'Down':
            {
                if (event.target) {
                    var linkItems = Array.from(document.querySelectorAll('.autocomplete__link'));
                    var nextIndex = linkItems.indexOf(event.target) + 1;
                    linkItems[nextIndex === linkItems.length ? 0 : nextIndex].focus();
                }
            }
            break;
        case 'ArrowUp':
        case 'Up':
            {
                var linkItems1 = Array.from(document.querySelectorAll('.autocomplete__link'));
                var nextIndex1 = linkItems1.indexOf(event.target) - 1;
                linkItems1[nextIndex1 === -1 ? linkItems1.length - 1 : nextIndex1].focus();
            }
            break;
        case 'Tab':
            {
                resultContainer.addClass("hidden");
                searchButton.focus();
            }
            break;
        case 'Escape':
        case 'Esc':
            {
                resultContainer.addClass("hidden");
                searchField.focus();
            }
            break;
        case 'ArrowRight':
        case 'Right':
            {
                var menus = Array.from(document.querySelectorAll('#searchquery-list, #www-list, #dokument-list, #person-list'))
                var currentMenu = menus.find(function (x) { return $(x).find(event.target).length > 0 });
                var nextIndex2 = menus.indexOf(currentMenu) + 1;

                var nextMenu = menus[nextIndex2 === menus.length ? 0 : nextIndex2];
                nextMenu.querySelector('.autocomplete__link').focus();
            }
            break;
        case 'ArrowLeft':
        case 'Left':
            {
                var menus1 = Array.from(document.querySelectorAll('#searchquery-list, #www-list, #dokument-list, #person-list'))
                var currentMenu1 = menus1.find(function (x) { return $(x).find(event.target).length > 0 });
                var prevIndex = menus1.indexOf(currentMenu1) - 1;

                var prevMenu = menus1[prevIndex === menus1.length ? 0 : prevIndex];
                prevMenu.querySelector('.autocomplete__link').focus();
            }
            break;
    }
}

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0].toLowerCase() === sParam.toLowerCase()) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

function getScopeUrlParam() {
    var scope = getUrlParameter("scope");
    if (!scope)
        scope = getUrlParameter("s");
    return scope;
}
function getHsaIdUrlParam() {
    var hsaId = getUrlParameter("hsaids");
    if (!hsaId)
        hsaId = getUrlParameter("HsaIdCollection");

    if (!hsaId)
        hsaId = "";
    return hsaId;
}
function addSearchQueries(queries, container) {
    var form = $("#search-form");
    var url = form.attr("action") + "?qc=true&q=";

    var header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Search suggestions" : "S&ouml;kordsf&ouml;rslag") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    var ulList = $(header).append("<ul id='searchquery-list' ></ul>").find("#searchquery-list");

    if (queries.length < 1) return;
    $.each(queries, function (i) {
        var format = (queries[i].format != null ? "file " + queries[i].format.substring(queries[i].format.lastIndexOf(".") + 1) : "file");
        var li = $("<li/>").appendTo(ulList);
        li.addClass(format);
        /*        var h3 = $("<h3>").appendTo(li);*/
        var aaa = $("<a >", {
            html: queries[i].label_hl,
            href: url + queries[i].label + scopeQuery + hsaIdQuery
        }).appendTo(li);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom sökordsförslag");
        if (queries[i].revisiondate != null || queries[i].scopelabel != null) {
            var source = $("<p>", {
                html: (queries[i].revisiondate != null ? queries[i].revisiondate : "") + (queries[i].scopelabel != null ? " - " + queries[i].scopelabel : "")
            }).appendTo(li);
        }
    });
}

function addWww(queries, container) {
      var form = $("#search-form");
    var header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Pages" : "Webb") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    var ulList = $(header).append("<ul id='www-list' ></ul>").find("#www-list");
   var url = form.attr("action") + "?qc=true&q=";
    if (queries.length < 1) return;
    $.each(queries, function (i) {
        if (i > 1)
            return;

        var li = $("<li/>").appendTo(ulList);
        li.addClass("image web");
        /*    var h3 = $("<h3>").appendTo(li);*/
        var aaa = $("<a>", {
            html: queries[i].label,            
            href: url + queries[i].label + scopeQuery + hsaIdQuery
        }).appendTo(li);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom Webb");
        if (queries[i].revisiondate != null || queries[i].scopelabel != null) {
            var source = $("<p>", {
                html: (queries[i].revisiondate != null ? queries[i].revisiondate : "") + (queries[i].scopelabel != null ? " - " + queries[i].scopelabel : "")
            }).appendTo(li);
        }
    });
}

function addDokument(queries, container) {
    var header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Documents" : "Dokument") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    var ulList = $(header).append("<ul id='dokument-list' ></ul>").find("#dokument-list");

    if (queries.length < 1) return;
    $.each(queries, function (i) {
        if (i > 1)
            return;
        var format = (queries[i].format != null ? "file " + queries[i].format.substring(queries[i].format.lastIndexOf(".") + 1) : "file");
        var li = $("<li/>").appendTo(ulList);
        li.addClass(format);
        var aaa = $("<a>", {
            html: queries[i].label,
            href:  '/dokument'  + "/?q=" + queries[i].label
        }).appendTo(li);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom dokument");
        if (queries[i].revisiondate != null || queries[i].scopelabel != null) {
            var source = $("<p>", {
                html: (queries[i].revisiondate != null ? queries[i].revisiondate : "") + (queries[i].scopelabel != null ? " - " + queries[i].scopelabel : "")
            }).appendTo(li);
        }
    });
}

function addVerksamhet(queries, container, isIntranet) {
    var header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Organizations" : "Verksamhet") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    var ulList = $(header).append("<ul id='verksamhet-list' ></ul>").find("#verksamhet-list");

    if (queries.length < 1) return;
    $.each(queries, function (i) {
        if (i > 1)
            return;
        var li = $("<li/>").appendTo(ulList);
        li.addClass("image business");
        var href = '';
        if (queries[i].hsaIdentity !== undefined) {
             if (isIntranet == true) {
                href = '/sok-verksamheter?hsaIdentity=' + queries[i].hsaIdentity;
            }
            else {
                href = '/verksamheter?hsaIdentity=' + queries[i].hsaIdentity;
            }
        } else {
            href = queries[i].url;
        }

        var aaa = $("<a>", {
            html: queries[i].label,
            href: href
        }).appendTo(li);
        aaa.attr('aria-label', queries[i].label + " inom verksamheter");
        aaa.addClass("autocomplete__link");
        if (queries[i].phonenumber != null) {
            var source = $("<p>", {
                html: "<a href='tel:" + queries[i].phonenumber + "' target='_top'>" + queries[i].phonenumber + "</a>"
            }).appendTo(li);
        }

    });
}

function addPerson(queries, container, isIntranet) {
    var header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Persons" : "Personer") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    var ulList = $(header).append("<ul id='person-list' ></ul>").find("#person-list");

    if (queries.length < 1) return;
    $.each(queries, function (i) {
        if (i > 1)
            return;
        var li = $("<li/>").appendTo(ulList);

        li.addClass("image person");
        /*        var h3 = $("<h3>").appendTo(li);*/

        var href = '';
        if (queries[i].vgrid !== undefined) {
             if (isIntranet == true) {
                href = '/sok-person?vgrid=' + queries[i].vgrid;
            }
            else {
                href = '/person?vgrid=' + queries[i].vgrid;
            }
        } else {
            href = queries[i].url;
        }

        var aaa = $("<a>", {
            html: queries[i].label,
            href: href,
        }).appendTo(li);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom person");
        if (queries[i].email != null) {
            var source = $("<p>", {
                html: "<a  href='mailto:" + queries[i].email + "' target='_top'>" + queries[i].email + "</a>"
            }).appendTo(li);
        }
    });
}
function addCloseResultContainerListener(searchField, searchButton, resultContainer) {
    closeResultContainerMousedown(resultContainer);
    closeResultContainerFocusin(searchField, searchButton, resultContainer);
    closeResultContainerEsc(resultContainer);
}

function closeResultContainerMousedown(resultContainer) {
    $("body").mousedown(function (e) {
        if (resultContainer.length > 0) {
            if (e.target.offsetParent == null || e.target.offsetParent.id !== resultContainer[0].id) {
                resultContainer.addClass("hidden");
            }
        }
    });
}

function closeResultContainerFocusin(searchField, searchButton, resultContainer) {
    $("body").focusin(function (e) {
        if (resultContainer.length > 0) {
            var focused = document.activeElement.id;
            if (focused !== searchField[0].id && focused !== searchButton[0].id && e.target.offsetParent && e.target.offsetParent.id !== resultContainer[0].id) {
                resultContainer.addClass("hidden");
            }
        }
    });
}

function closeResultContainerEsc(resultContainer) {
    $(document).on("keyup", function (evt) {
        if (evt.keyCode == escape) {
            resultContainer.addClass("hidden");
        }
    });
}

export { handleKeyDown, getScopeUrlParam, getHsaIdUrlParam, addSearchQueries, addWww, addDokument, addVerksamhet, addPerson, addCloseResultContainerListener };
